import React, { useState } from 'react';
import { ArrowUpRight } from 'lucide-react';

// Founder card, shown inside the Contact section. The full portfolio lives on its own site,
// omarfaiz.vetobase.com. Facts match public/ownership.html; the owner
// wants the title shown as "Founder" only. Keep the description factual.
export const LINKEDIN_URL = 'https://www.linkedin.com/in/omar-faiz-9aa2752b8/';
const FOUNDER_PHOTO = '/founder-omar-faiz.jpg';

const focusRing = 'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ink focus-visible:ring-offset-2 focus-visible:ring-offset-card';

export const LinkedInIcon = ({ className }) => (
    <svg className={className} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" focusable="false">
        <path d="M20.45 20.45h-3.56v-5.57c0-1.33-.02-3.04-1.85-3.04-1.85 0-2.14 1.45-2.14 2.94v5.67H9.35V9h3.41v1.56h.05c.48-.9 1.64-1.85 3.37-1.85 3.6 0 4.27 2.37 4.27 5.46v6.28zM5.34 7.43a2.06 2.06 0 1 1 0-4.13 2.06 2.06 0 0 1 0 4.13zM7.12 20.45H3.56V9h3.56v11.45zM22.22 0H1.77C.79 0 0 .77 0 1.73v20.54C0 23.23.79 24 1.77 24h20.45c.98 0 1.78-.77 1.78-1.73V1.73C24 .77 23.2 0 22.22 0z" />
    </svg>
);

const FounderCard = () => {
    const [photoFailed, setPhotoFailed] = useState(false);
    return (
        <div id="founder" className="p-5 rounded-2xl bg-paper border border-borderLight scroll-mt-24">
            <span className="text-[10px] font-mono text-textMuted uppercase tracking-label">Founder</span>
            <div className="mt-3 flex items-center gap-4">
                <a
                    href={LINKEDIN_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Omar Faiz on LinkedIn (opens in a new tab)"
                    className={`flex-shrink-0 rounded-full ${focusRing}`}
                >
                    <span className="block p-1 rounded-full bg-card border border-ink shadow-hard-sm">
                        <span className="block w-16 h-16 rounded-full overflow-hidden bg-ink">
                            {!photoFailed ? (
                                <img
                                    src={FOUNDER_PHOTO}
                                    alt="Omar Faiz, Founder of Vetobase"
                                    width="128"
                                    height="128"
                                    loading="lazy"
                                    onError={() => setPhotoFailed(true)}
                                    className="w-full h-full object-cover object-[45%_35%]"
                                />
                            ) : (
                                <span aria-hidden="true" className="w-full h-full flex items-center justify-center font-serif-italic text-paper text-2xl">OF</span>
                            )}
                        </span>
                    </span>
                </a>
                <div className="flex flex-col min-w-0">
                    <span className="text-lg font-bold text-ink tracking-head leading-tight">Omar Faiz</span>
                    <span className="text-sm text-textSecondary">Founder, Vetobase (SMC-Private) Limited</span>
                </div>
            </div>
            <p className="mt-3 text-sm text-textBody leading-relaxed">
                Omar founded Vetobase to help businesses automate their customer conversations and the day-to-day
                operations around them. Happy to talk about how Vetobase AI could work for your team.
            </p>
            <div className="mt-4 flex flex-wrap items-center gap-2.5">
                <a
                    href={LINKEDIN_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-track="founder_linkedin"
                    className={`inline-flex items-center gap-2 bg-ink text-paper pl-3.5 pr-4 py-2.5 rounded-full text-sm font-bold shadow-hard-soft hover:bg-black active:scale-95 transition-all ${focusRing}`}
                >
                    <LinkedInIcon className="w-4 h-4" />
                    Connect on LinkedIn
                    <ArrowUpRight className="w-3.5 h-3.5" aria-hidden="true" />
                    <span className="sr-only">(opens in a new tab)</span>
                </a>
                <a
                    href="https://omarfaiz.vetobase.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className={`inline-flex items-center gap-1.5 px-4 py-2.5 rounded-full bg-card border border-borderLight text-sm font-semibold text-ink hover:border-ink transition-all ${focusRing}`}
                >
                    Full portfolio ↗
                    <span className="sr-only">(opens omarfaiz.vetobase.com in a new tab)</span>
                </a>
            </div>
        </div>
    );
};

export default FounderCard;
